module.exports = __webpack_public_path__ + "static/media/hulk.b489aa37.jpg";